import {gql} from 'apollo-boost';

export const GET_PRIVATE_MESSAGE = gql`
  query getPrivateMessage($id: ID!){
    getPrivateMessage(id: $id) {
      id toUserCode fromUserCode
      topic message sendDate hasNewReply newReplyDate readDate
      ip isFromTeacher isFromStudent
      academicPeriod {id periodCode}
      courseOutlineRegistration { id }
      classSection { id }
      toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      privateMessageReplies {
        id toUserCode fromUserCode message sendDate isRead readDate
        ip isFromTeacher isFromStudent
        privateMessage { id }
        toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
        fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      }
    }
  }
`;

export const GET_PRIVATE_MESSAGES = gql`
  query getPrivateMessages($id : ID!){
    getPrivateMessages (
      id: $id
    ) {
      id toUserCode fromUserCode
      topic message sendDate hasNewReply newReplyDate readDate
      ip isFromTeacher isFromStudent
      academicPeriod {id periodCode}
      courseOutlineRegistration { id }
      classSection { id }
      toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      privateMessageReplies {
        id toUserCode fromUserCode message sendDate isRead readDate
        ip isFromTeacher isFromStudent
        privateMessage { id }
        toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
        fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      }
    }
  }
`;

export const GET_PRIVATE_MESSAGES_BY_FILTER = gql`
  query getPrivateMessagesByFilter($privateMessageFilterInput: PrivateMessageFilterInput){
    getPrivateMessagesByFilter (
      privateMessageFilterInput: $privateMessageFilterInput
    ) {
      id toUserCode fromUserCode
      topic message sendDate hasNewReply newReplyDate readDate
      ip isFromTeacher isFromStudent
      academicPeriod {id periodCode}
      courseOutlineRegistration { id }
      classSection { id }
      toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      privateMessageReplies {
        id toUserCode fromUserCode message sendDate isRead readDate
        ip isFromTeacher isFromStudent
        privateMessage { id }
        toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
        fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      }
    }
  }
`;

export const GET_PRIVATE_MESSAGES_SEND_TO_CURRENT_USER = gql`
  query getPrivateMessagesSendToCurrentUser($academicPeriodId: ID!){
    getPrivateMessagesSendToCurrentUser (
      academicPeriodId: $academicPeriodId
    ) {
      id toUserCode fromUserCode
      topic message sendDate hasNewReply newReplyDate readDate
      ip isFromTeacher isFromStudent
      academicPeriod {id periodCode}
      courseOutlineRegistration { id subjectCode }
      classSection { id sectionNo}
      toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      privateMessageReplies {
        id toUserCode fromUserCode message sendDate isRead readDate
        ip isFromTeacher isFromStudent
        privateMessage { id }
        toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
        fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      }
      updatedAt
      updatedBy { id }
    }
  }
`;

export const GET_PRIVATE_MESSAGES_SEND_FROM_CURRENT_USER = gql`
  query getPrivateMessagesSendFromCurrentUser($academicPeriodId: ID!){
    getPrivateMessagesSendFromCurrentUser (
      academicPeriodId: $academicPeriodId
    ) {
      id toUserCode fromUserCode
      topic message sendDate hasNewReply newReplyDate readDate
      ip isFromTeacher isFromStudent
      academicPeriod {id periodCode}
      courseOutlineRegistration { id subjectCode }
      classSection { id sectionNo}
      toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      privateMessageReplies {
        id toUserCode fromUserCode message sendDate isRead readDate
        ip isFromTeacher isFromStudent
        privateMessage { id }
        toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
        fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      }
      updatedAt
      updatedBy { id }
    }
  }
`;

export const GET_COURSES_OF_PRIVATE_MESSAGES_CURRENT_STUDENT = gql`
  query getCoursesOfPrivateMessagesCurrentStudent($academicPeriodId: ID!){
    getCoursesOfPrivateMessagesCurrentStudent (
      academicPeriodId: $academicPeriodId
    ) {
      id
      classSection { id sectionNo }
      subjectCode
    }
  }
`;

export const GET_COURSES_OF_PRIVATE_MESSAGES_CURRENT_TEACHER = gql`
  query getCoursesOfPrivateMessagesCurrentTeacher($academicPeriodId: ID!){
    getCoursesOfPrivateMessagesCurrentTeacher (
      academicPeriodId: $academicPeriodId
    ) {
      id
      classSection { id sectionNo }
      subjectCode
    }
  }
`;

export const ADD_PRIVATE_MESSAGE = gql`
  mutation addPrivateMessage(
    $courseOutlineRegistrationId: ID!,
    $classSectionId: ID!,
    $academicPeriodId: ID!,
    $toUserId: ID!,
    $privateMessageInput: PrivateMessageInput!
  ) {
    addPrivateMessage(
      courseOutlineRegistrationId: $courseOutlineRegistrationId
      classSectionId: $classSectionId
      academicPeriodId: $academicPeriodId
      toUserId: $toUserId
      privateMessageInput: $privateMessageInput
    ) {
      id toUserCode fromUserCode
      topic message sendDate hasNewReply newReplyDate readDate
      ip isFromTeacher isFromStudent
      academicPeriod {id periodCode}
      courseOutlineRegistration { id subjectCode}
      classSection { id sectionNo}
      toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      privateMessageReplies {
        id toUserCode fromUserCode message sendDate isRead readDate
        ip isFromTeacher isFromStudent
        privateMessage { id }
        toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
        fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      }
      updatedAt
      updatedBy { id }
    }
  }
`;

export const UPDATE_PRIVATE_MESSAGE = gql`
  mutation updatePrivateMessage(
    $id: ID!,
    $courseOutlineUnitId: ID!,
    $privateMessageInput: PrivateMessageInput!
  ) {
    updatePrivateMessage(
      id: $id
      privateMessageInput: $privateMessageInput
    ) {
      id toUserCode fromUserCode
      topic message sendDate hasNewReply newReplyDate readDate
      ip isFromTeacher isFromStudent
      academicPeriod {id periodCode}
      courseOutlineRegistration { id }
      classSection { id }
      toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      privateMessageReplies {
        id toUserCode fromUserCode message sendDate isRead readDate
        ip isFromTeacher isFromStudent
        privateMessage { id }
        toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
        fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      }
    }
  }
`;

export const UPDATE_PRIVATE_MESSAGE_ALREADY_READ = gql`
  mutation updatePrivateMessageAlreadyRead(
    $id: ID!,
  ) {
    updatePrivateMessageAlreadyRead(
      id: $id
    ) {
      id toUserCode fromUserCode
      topic message sendDate hasNewReply newReplyDate readDate
      ip isFromTeacher isFromStudent
      academicPeriod {id periodCode}
      courseOutlineRegistration { id subjectCode }
      classSection { id sectionNo}
      toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      privateMessageReplies {
        id toUserCode fromUserCode message sendDate isRead readDate
        ip isFromTeacher isFromStudent
        privateMessage { id }
        toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
        fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      }
      updatedAt
      updatedBy { id }
    }
  }
`;

export const DELETE_PRIVATE_MESSAGE = gql`
  mutation deletePrivateMessage($id: ID!) {
    deletePrivateMessage(
      id: $id
    ) {
      id toUserCode fromUserCode
      topic message sendDate hasNewReply newReplyDate readDate
      ip isFromTeacher isFromStudent
      academicPeriod {id periodCode}
      courseOutlineRegistration { id }
      classSection { id }
      toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      privateMessageReplies {
        id toUserCode fromUserCode message sendDate isRead readDate
        ip isFromTeacher isFromStudent
        privateMessage { id }
        toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
        fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      }
    }
  }
`;

